// extracted by mini-css-extract-plugin
export default {"toggle":"i1TK9JNPj8TjtlSMuDN9"};